import React, { useState } from 'react';
import {IconChipMultiplePerson, IconDoor, IconTwoPersons} from '../../components/buttons/IconButtons';
import CustomTooltip from '../../components/CustomTooltip';
import { TabPanelApp } from '../../components/ResourceAssignment/Functionality/TabPanelApp';
import AssignedTabResource from '../../components/ResourceAssignment/SubComponents/AssignedTabResource';
import { AssignedBuildingDetailsResourceApp } from './Functionality/AssignedBuildingDetailsResourceApp';
import {TABLES} from "../../Apis/Tables";

/**
 * @Author: karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer
 * @Email : kpozos@ibl.mx
 *
 * Read-only assigned list for one building resource (residents / units) inside
 * the list detail expand. Owns its own tab state and renders the assigned page
 * through AssignedTabResource in readOnly mode (no checkbox, no deletion).
 * Mirrors WorkShiftRenderDetails.
 */
const RenderAssignedSection = ({ resource, id, title, Icon }) => {
    const [selected, setSelected] = useState([]);
    const [selectForDelete, setSelectForDelete] = useState([]);

    const {
        t,
        results, setResults,
        setBodyForExport,
        searchElement, setSearchElement,
        setSearch,
        setSimpleSearch,
        modified, setModified,
        triggerDelete, setTriggerDelete,
        isAllChecked, setIsAllChecked,
    } = TabPanelApp();

    return (
        <AssignedTabResource
            useAssignedApp={AssignedBuildingDetailsResourceApp}
            readOnly={true}
            resource={resource}
            id={id}
            selected={selected}
            setSelected={setSelected}
            selectForDelete={selectForDelete}
            setSelectForDelete={setSelectForDelete}
            isAllChecked={isAllChecked}
            setIsAllChecked={setIsAllChecked}
            triggerDelete={triggerDelete}
            setTriggerDelete={setTriggerDelete}
            searchElement={searchElement}
            setSearchElement={setSearchElement}
            results={results}
            setResults={setResults}
            setBodyForExport={setBodyForExport}
            setSearch={setSearch}
            setSimpleSearch={setSimpleSearch}
            modified={modified}
            setModified={setModified}
            renderModuleTitle={
                <div className='d-flex align-items-center justify-content-start mb-3'>
                    <div><Icon className="mr-8px mb-1" /></div>
                    <div className={`mr-5 flex-grow-1 minw-0 p-0`}>
                        <CustomTooltip
                            text={t(title)}
                            classes={`fs-14px font-color-general-950 ibl-font-w-600 text-ellipsis-1-row `}
                            showIfTruncated={true}
                        />
                    </div>
                    <div className='vertical-separator-shades-950 h-auto' />
                </div>
            }
        />
    );
};

/**
 * Expanded row detail for a building list entry. Renders the building's assigned
 * residents, units and employees as read-only paginated lists, reading the
 * building is enough to open all three.
 *
 * @param {Object} props
 * @param {Object} props.row - Building list row ({ id }).
 * @returns {JSX.Element}
 */
const BuildingRenderDetails = ({ row }) => {
    return (
        <div className='shift-detail-lists'>
            <RenderAssignedSection
                resource={TABLES.BUILDING_APARTMENT_RESIDENT}
                id={row?.id}
                title={'residents'}
                Icon={IconTwoPersons}
            />
            <RenderAssignedSection
                resource={TABLES.BUILDING_APARTMENT}
                id={row?.id}
                title={'assigned_units'}
                Icon={IconDoor}
            />
            <RenderAssignedSection
                resource={TABLES.BUILDING_USER}
                id={row?.id}
                title={'assigned_employees'}
                Icon={IconChipMultiplePerson}
            />
        </div>
    );
};

export default BuildingRenderDetails;
